"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const SettingsContainer = styled_components_1.default.div `
  position: absolute;
  top: 20px;
  right: 20px;
  width: 42vmin;
  max-height: 80vh;
  padding-left: 10px;
  overflow-y: auto;
  z-index: 10;
  font-size: 2vmin;
  background-color: rgba(99, 152, 233, 0.8);
  border: solid 1px;
  box-shadow: 1px 1px 3px;

  .btn-active {
    background-color: green;
  }
  button {
    height: 4.5vmin;
    width: 5vmin;
    font-size: 1.75vmin;
  }

  .minimize-settings {
    position: absolute;
    right: 0;
  }

  p,
  a {
    color: #fff;
  }

  .info-container {
    margin: 1vmin 0;
  }

  .info-icon {
    height: 2.5vmin;
    width: 2.5vmin;
    margin: 0.5vmin;
    vertical-align: middle;
    color: #fff;
  }
`;
const ShowSettingsButton = styled_components_1.default.button `
  position: absolute;
  top: 20px;
  right: 20px;
  height: 4.5vmin;
  width: 6vmin;
  font-size: 1.75vmin;
  z-index: 99;
`;
const speeds = [1, 2, 3, 4, 5, 10];
const Settings = (props) => {
    const { slides, activeIndex, setActiveIndex, speed, setSpeed, toggleSlideShow, stopSlideShow, stopAnimations, toggleAnimations, } = props;
    const [isMinimized, setIsMinimized] = (0, react_1.useState)(false);
    return !isMinimized ? (react_1.default.createElement(ShowSettingsButton, { onClick: () => setIsMinimized(true) }, "+")) : (react_1.default.createElement(SettingsContainer, null,
        react_1.default.createElement("button", { className: "minimize-settings", onClick: () => setIsMinimized(false) }, "_"),
        react_1.default.createElement("p", null, "Slide Select "),
        slides.map((slide, index) => (react_1.default.createElement("button", { className: index === activeIndex ? "btn-active" : "", onClick: () => {
                setActiveIndex(index);
            }, key: (0, react_uid_1.uid)(index) },
            "#",
            index))),
        react_1.default.createElement("p", null, "Speed Select "),
        react_1.default.createElement("div", null, speeds.map((speedOption) => (react_1.default.createElement("button", { className: speedOption === speed ? "btn-active" : "", onClick: () => {
                setSpeed(speedOption);
            }, key: speedOption },
            speedOption,
            "x")))),
        react_1.default.createElement("p", null, "Slideshow enabled"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("button", { className: !stopSlideShow ? "btn-active" : "", onClick: () => {
                    toggleSlideShow(false);
                } }, "Yes"),
            react_1.default.createElement("button", { className: stopSlideShow ? "btn-active" : "", onClick: () => {
                    toggleSlideShow(true);
                } }, "No")),
        react_1.default.createElement("p", null, "Animations enabled"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("button", { className: !stopAnimations ? "btn-active" : "", onClick: () => {
                    toggleAnimations(false);
                } }, "Yes"),
            react_1.default.createElement("button", { className: stopAnimations ? "btn-active" : "", onClick: () => {
                    toggleAnimations(true);
                } }, "No")),
        react_1.default.createElement("div", { className: "info-container" },
            react_1.default.createElement(Info_1.default, { className: "info-icon" }),
            react_1.default.createElement("a", { href: "https://help.hotel-mssngr.com/en/articles/6365085-set-up-auto-play-for-videos-on-chrome-and-safari", target: "_blank", rel: "noreferrer" }, "Videos/Sound not playing? Click here to find out why."))));
};
exports.default = Settings;
